import Rete from "rete";
import { NumberSocket,NumberControl } from "../rete-controls/NumberControl.js"
import ReteComponentStore from "../ReteComponentStore.js"

export default class NumberDisplayComponent extends Rete.Component {
    constructor(){
        super("Number Display"); // name
        this._categories = ["Output Nodes", "tryMe"];
    }

    builder(node) {
        let inp1 = new Rete.Input('in1','IN',NumberSocket);
        let out1 = new Rete.Output('out1','OUT',NumberSocket);
        let numControl = new NumberControl(this.editor,"display",true);

        return node
        .addInput(inp1)
        .addOutput(out1)
        .addControl(numControl);
    }

    worker(node, inputs, outputs) {
        
        outputs['out1'] = +inputs['in1'];
        this.editor.nodes
        .find(n => n.id == node.id)
        .controls.get("display")
        .setValue(outputs['out1'].toFixed(2) );

        //console.log(this.name + "node.data=" + JSON.stringify(node.data));
        //console.log(this.name + "outputs=" + JSON.stringify(outputs));
        //console.log(this.name + "inputs=" + JSON.stringify(inputs));

 
    }
}

//ReteComponentStore.add(new NumberDisplayComponent());